import React from 'react';
import { usePageMotion } from '../hooks/usePageMotion';
import './Companies.css';

interface Company {
  name: string;
  role: string;
  period: string;
  description: string;
  technologies: string[];
}

const Companies: React.FC = () => {
  const root = usePageMotion<HTMLDivElement>();
  const experiences: Company[] = [
    {
      name: 'Studio Formaturas',
      role: 'Desenvolvedor Full Stack & Analista de Sistemas',
      period: '2022 - Presente',
      description: 'Desenvolvo o Syncronize Release com Java e Spring, um sistema de agendamentos voltado para a rotina de empresas de formaturas e eventos.',
      technologies: ['Java', 'Spring', 'Spring Boot', 'Git', 'GitHub']
    },
    {
      name: 'SGE — Sistema de Gestão de Formaturas e Eventos',
      role: 'Analista de Testes / QA',
      period: 'Atual',
      description: 'Elaboração de cenários e casos de teste para o sistema web de gestão e para o aplicativo iFormando, cobrindo fluxos funcionais, regras de negócio, regressão e cenários de exceção.',
      technologies: ['Testes funcionais', 'Android/iOS', 'Sistemas web', 'Documentação de QA', 'Testes de regressão']
    },
    {
      name: 'Projetos Independentes',
      role: 'Desenvolvedor Full Stack',
      period: '2021 - Presente',
      description: 'Desenvolvimento back-end com Java e Spring, combinando a visão de construção de software com práticas de qualidade e validação.',
      technologies: ['Java', 'Spring Boot', 'Git', 'Metodologias ágeis']
    }
  ];

  return (
    <div className="companies-page" ref={root}>
      <section className="companies-hero">
        <div className="container" data-hero-reveal>
          <span className="eyebrow">Desenvolvimento e QA</span>
          <h1 className="page-title">Experiência Profissional</h1>
          <p className="page-subtitle">
            Experiência em todo o ciclo do software: da construção à validação.
          </p>
        </div>
      </section>

      <section className="timeline-section">
        <div className="container">
          <div className="timeline">
            {experiences.map((experience, index) => (
              <div key={index} className="timeline-item" data-reveal>
                <div className="timeline-marker"></div>
                <div className="timeline-content">
                  <div className="company-card">
                    <div className="company-header">
                      <div className="company-info">
                        <h3 className="company-name">{experience.name}</h3>
                        <p className="company-role">{experience.role}</p>
                        <p className="company-period">
                          <i className="fas fa-calendar-alt"></i>
                          {experience.period}
                        </p>
                      </div>
                    </div>
                    <p className="company-description">{experience.description}</p>
                    <div className="company-technologies">
                      {experience.technologies.map((tech, idx) => (
                        <span key={idx} className="tech-badge">{tech}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="skills-highlight">
        <div className="container">
          <h2 className="section-title">Principais Competências</h2>
          <div className="skills-list">
            <div className="skill-item">
              <i className="fas fa-check-circle"></i>
              <span>Elaboração de cenários e casos de teste</span>
            </div>
            <div className="skill-item">
              <i className="fas fa-check-circle"></i>
              <span>Testes funcionais e de regressão</span>
            </div>
            <div className="skill-item">
              <i className="fas fa-check-circle"></i>
              <span>Testes de aplicações Android/iOS e sistemas web</span>
            </div>
            <div className="skill-item">
              <i className="fas fa-check-circle"></i>
              <span>Documentação de QA e regras de negócio</span>
            </div>
            <div className="skill-item">
              <i className="fas fa-check-circle"></i>
              <span>Desenvolvimento Java com Spring Boot</span>
            </div>
            <div className="skill-item">
              <i className="fas fa-check-circle"></i>
              <span>Arquitetura de Software e Banco de Dados</span>
            </div>
            <div className="skill-item">
              <i className="fas fa-check-circle"></i>
              <span>Automação de Processos Empresariais</span>
            </div>
            <div className="skill-item">
              <i className="fas fa-check-circle"></i>
              <span>Gestão de Projetos e Metodologias Ágeis</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Companies;
